import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

export const ACCOUNT_INFO_REQUEST = 'account/REQUEST'
export const ACCOUNT_INFO_SUCCESS = 'account/SUCCESS'
export const ACCOUNT_INFO_ERROR = 'account/ERROR'

export function requestSuccess(resp) {
    const {
        id,
        clan,
        role,
        flags,
        permissions,
        periphery_id,
        periphery_name,
        available_features,
        elo_leaderboards,
    } = resp

    return {
        type: ACCOUNT_INFO_SUCCESS,
        payload: {
            id,
            clan,
            role,
            flags,
            permissions,
            periphery_id,
            periphery_name,
            available_features,
            elo_leaderboards,
        },
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: ACCOUNT_INFO_ERROR,
        payload: errorData,
    }
}

export default function requestAccountInfo() {
    return async (dispatch, getState) => {
        if (getState().account.loading) {
            return
        }
        dispatch({ type: ACCOUNT_INFO_REQUEST })

        httpRequest('/game_api/account_info')
            .then(
                resp => {
                    window.__WGSH_GA_ROLE__ = resp.role
                    dispatch(requestSuccess(resp))
                },
                errorData => dispatch(requestError(errorData))
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/account.js